export const videos = [
  {
    // A unique ID for each video
    id: 1,
    // The title of the video
    title: "The Story So Far",
    // The unique ID from the YouTube URL.
    // For a URL like "https://www.youtube.com/watch?v=dQw4w9WgXcQ", the ID is "dQw4w9WgXcQ"
    youtubeId: "4V21oY2N5ew",
    // An optional caption or description
    caption: "The NH Rhatigan's first few years as a family ❤️",
    // The date the video was uploaded or recorded
    date: "2022-08-12",
  },
  {
    // A unique ID for each video
    id: 2,
    // The title of the video
    title: "Rockin' Reindeer - Christmas '92",
    // The unique ID from the YouTube URL.
    // For a URL like "https://www.youtube.com/watch?v=dQw4w9WgXcQ", the ID is "dQw4w9WgXcQ"
    youtubeId: "s2NBZb4zVFk",
    // An optional caption or description
    caption: "Merry Christmasss, Errehbodddyyyy!",
    // The date the video was uploaded or recorded
    date: "1992-12-09",
  },
];
